// Graphics quality: 'high' | 'low'. Weaker devices (standalone XR headsets,
// mobiles, low-memory machines) default to 'low'; a localStorage override
// wins either way. Consumers read this once at effect-creation time, so a
// change needs a reload.
const STORAGE_KEY = 'graphicsQuality';

export function detectWeakDevice() {
	const ua = navigator.userAgent || '';
	if (/Pico|Quest|OculusBrowser|XRBrowser|Wolvic/i.test(ua)) return true;
	if (navigator.deviceMemory && navigator.deviceMemory <= 4) return true;
	if (/Android|Mobile|iPhone|iPad/i.test(ua)) return true;
	return false;
}

export function getGraphicsQuality() {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored === 'low' || stored === 'high') return stored;
	} catch { /* storage blocked — fall through to detection */ }
	return detectWeakDevice() ? 'low' : 'high';
}

export function setGraphicsQuality(quality) {
	if (quality !== 'low' && quality !== 'high') throw new Error(`graphics quality must be 'low' or 'high', got '${quality}'`);
	try { localStorage.setItem(STORAGE_KEY, quality); } catch { /* storage blocked */ }
	return quality;
}
